import type { NavigateOptions } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { scrollToSection as scrollToSectionUtil } from '@/utils/scroll';

export function useHeader(
  navigate: (options: NavigateOptions) => void,
  isCatalogPage: boolean,
  isProductPage: boolean
) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href: string) => {
    scrollToSectionUtil(href, {
      onComplete: () => {
        setIsMenuOpen(false);
      },
    });
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleBackClick = () => {
    if (isCatalogPage) {
      navigate({ to: '/' });
      return;
    }

    if (isProductPage) {
      const origin = sessionStorage.getItem('productOrigin');

      if (origin === 'catalog') {
        navigate({ to: '/catalog', search: { category: 'all', page: 1 } });
      } else {
        navigate({ to: '/' });
      }
    }
  };

  const hasBackground = isScrolled || isMenuOpen;

  return {
    isMenuOpen,
    isScrolled,
    hasBackground,
    scrollToSection,
    toggleMenu,
    closeMenu,
    handleBackClick,
  };
}
